import React, { useState, useEffect } from 'react';
import './App.css';
import { FaApple, FaAndroid, FaCheck } from "react-icons/fa";
import 'bootstrap/dist/css/bootstrap.min.css';
import { Button, Container } from "react-bootstrap";
import logo from "./logo.png";
import GizlilikPolitikasi from './GizlilikPolitikasi';

function Sozlesme({ kabulEdildi }) {
  return (
    <>
      <img src={logo} alt="logo" />
      <br /><br />
      SECURITAS “SmartM” KULLANICI SÖZLEŞMESİ<br />
      <br />
      “SmartM” üyesi olmak için, önce kayıt formunu doldurmanız ve Securitas üyelik sözleşmesi hükümlerine uymayı kabul ve taahhüt etmeniz gereklidir. Kullanıcı, kayıt formunu doldurup onayladığı andan itibaren Securitas “SmartM” sözleşmesine uymayı taahhüt etmiş kabul edilir.<br />
      <br />
      “SmartM” ile Securitas çalışanı olan Portal üyesine Securitas nezdinde çalıştığı süre ile sınırlı olmak üzere, Securitas Türkiye bünyesinde görev yapan diğer çalışanlar ile iletişim kurmak, özlük, bordro, puantaj, izin, performans ve denetim gibi kendilerine ait bilgilere erişebilme ve Securitas Türkiye bünyesindeki süreli yayınları ve dökümanları takip edebilme imkanı sağlanması amaçlanmaktadır.<br />
      <br />
      “SmartM” de yer alan kayıtlar yalnızca bilgi amaçlı olup hiçbir şekilde kesin nitelik taşımaz. Herhangi bir ihtilaf halinde yalnızca Securitas kayıtları geçerlidir.<br />
      <br />
      Üye, “SmartM” den  yararlandığı sırada;<br />
      <br />
      Kayıt formunda yer alan bilgilerin doğru olduğunu ve bu bilgilerin gerekli olduğu durumlarda bilginin hatalı veya noksan olmasından (şifre unutma gibi) doğacak zararlardan dolayı sorumluluğun kendisine ait olduğunu, bu hallerde üyeliğinin sona erebileceğini,<br />
      <br />
      Securitas tarafından verilen Portal servislerinin ve yazılımlarının telif hakkının Securitas'a ait olduğunu, bu yazılımları hiçbir şekilde çoğaltıp, dağıtmayacağını,<br />
      <br />
      SmartM servislerini kullandığında ileri sürdüğü şahsi fikir, düşünce, ifade, Portal ortamına eklediği dosyaların, gönderdiği kişilik bilgilerinin sorumluluğunun kendisine ait olduğunu ve Securitas’ın bu dosyalardan dolayı hiçbir şekilde sorumlu tutulamayacağını,<br />
      <br />
      Portal’ın kullanımı sırasında kaybolacak, ve/veya eksik alınacak, yanlış adrese iletilecek bilgi mesaj ve dosyalardan Securitas’ın sorumlu olmayacağını,<br />
      <br />
      Portal’da sunulan hizmetlere Securitas tarafından belirlenen şekil dışında ve yetkisiz şekilde ulaşmamayı ve yazılımı hiçbir şekilde değiştirmemeyi, değiştirilmiş olduğu belli olanları kullanmamayı ve sözü geçen maddelere uymadığı durumlarda Securitas’ın uğrayabileceği tüm maddi ve manevi zararları ödemeyi,<br />
      <br />
      Üye verilerinin yetkisiz kişilerce okunması sebebiyle gelebilecek zararlardan ötürü Securitas’ın sorumlu olmayacağını,<br />
      <br />
      Tehdit edici, ahlak dışı, ırkçı, Türkiye Cumhuriyeti Yasalarına, Uluslararası anlaşmalara aykırı mesajlar göndermemeyi, Ulusal ve uluslararası sendikal mevzuata aykırı hareket etmemeyi, Ortama eklenecek yazışma, konu başlıkları, rumuzların genel ahlak, görgü ve hukuk kurallarına uygun olmasını, Diğer kullanıcıları taciz ve tehdit etmemeyi, Diğer kullanıcıların Portalı kullanmasını etkileyecek şekilde davranmamayı, İşveren ve/veya Portal Yöneticisinin yazılı izni olmaksızın Portal üzerinden her ne ad altında olursa olsun örgütlenme çalışması yapmamayı, Kişi ya da kurumların isimlerini lekeleyici, çiğneyici, ahlaka aykırı, yakışıksız ya da kanun dışı materyal ya da bilgiler yayımlamamayı, basmamayı, dağıtmamayı, Reklam yapmamayı, herhangi bir mal ya da hizmet satmamayı ya da satılmasına yönelik teklifte bulunmamayı, anket, yarışma faaliyetlerinde bulunmamayı, Diğer kullanıcıların bilgisayarındaki bilgilere ya da yazılıma zarar verecek bilgi veya programlar göndermemeyi, Kanunlara göre postalanması yasak olan bilgileri postalamamayı ve zincir posta(chain mail), yazılım virüsü (vb.) gibi gönderilme yetkisi olmayan postaları dağıtmamayı, Başkalarına ait olan kişisel bilgileri kayıt etmemeyi, kötüye kullanmamayı,<br />
      <br />
      Üye "kullanıcı" adıyla yapacağı her türlü işlemden bizzat kendisinin sorumlu olduğunu,<br />
      <br />
      Securitas’ın, dilediği zaman veya sürekli olarak tüm sistemi izleyebileceğini, Kurallara aykırı davrandığı takdirde Securitas’ın gerekli müdahalelerde bulunma ve üyeyi Portal dışına çıkarma ve üyeliğe son verme hakkına sahip olduğunu,<br />
      <br />
      Securitas’ın kendi sistemini ticari amaçla kullanabileceğini,<br />
      <br />
      “SmartM” kullanarak elde edilen kayıt ve bilgilerin tamamının kullanıcının rızası dahilinde olduğunu,<br />
      <br />
      Kabul ve taahhüt eder<br />
      <br />
      Securitas herhangi bir zamanda Portal’ın çalışmasını geçici bir süre askıya alabilir veya tamamen durdurabilir. Portal’ın geçici bir süre askıya alınması veya tamamen durdurulmasından dolayı Securitas" ın üyelerine veya üçüncü şahıslara karşı hiçbir sorumluluğu bulunmamaktadır.<br />
      <br />
      Securitas ileride doğacak teknik zaruretler ve mevzuata uyum amacıyla işbu sözleşmenin uygulamasında değişiklikler yapabilir, mevcut maddelerini ya da Portal’da verilen hizmetleri değiştirebilir ve dilediği zaman tek taraflı olarak bu sözleşmeyi ve Portal’da verilen hizmetleri sonlandırabilir.
      <br /><br />

      <Button variant="success" onClick={kabulEdildi}>
        <FaCheck /> Okudum, Kabul Ediyorum
      </Button>
    </>
  );
}

function Kurulum() {

  const params = new URL(window.location).searchParams;

  let os = params.get("os");
  if (os !== "ios" && os !== "android") {
    os = null;
  }

  const [sozlesmeKabulEdildi, setSozlesmeKabulEdildi] = useState(os !== null);


  if (!sozlesmeKabulEdildi) {
    return (
      <Sozlesme kabulEdildi={() => { setSozlesmeKabulEdildi(true) }} />
    );
  }


  const IndirStoreButtons = () => {
    return (
      <div style={{ display: "flex", flexDirection: "column", gap: 16, alignItems: "center" }}>

        {/* App Store */}
        <img
          src="/app-store.svg"
          alt="App Store"
          style={{ width: 200, cursor: "pointer" }}
          onClick={() => {
            window.location = "https://apps.apple.com/tr/app/securitas-smartm/id6746545294";
          }}
        />

        {/* Google Play */}
        <img
          src="/google-play.svg"
          alt="Google Play"
          style={{ width: 200, cursor: "pointer" }}
          onClick={() => {
            window.location = "https://play.google.com/store/apps/details?id=tr.com.securitas.smartmobile";
          }}
        />

        {/* Huawei AppGallery */}
        <img
          src="/huawei-appgallery.png"
          alt="AppGallery"
          style={{ width: 200, cursor: "pointer" }}
          onClick={() => {
            window.location = "https://appgallery.huawei.com/app/C117480335";
          }}
        />

      </div>
    );
  };


  return (
    <>
      <IndirStoreButtons />
      <br /><br />
      <a className="App-link" href="#" onClick={e => { e.preventDefault(); setSozlesmeKabulEdildi(false) }} >
        Sözleşmeyi tekrar görüntüle
      </a>
    </>
  );
}

export default function App() {

  const path = window.location.pathname.toLowerCase();

  if (path.includes("gizlilik-politikasi")) {
    return (
      <div className="App">
        <Container>
          <GizlilikPolitikasi />
        </Container>
      </div>
    );
  }

  return (
    <div className="App">
      <header className="App-header">
        <Container>
          <Kurulum />
        </Container>
      </header>
    </div>
  );
}
